<template>
    <div class="formWrapper">
        <div id="pasteZone" class="shadow">
            <textarea
                maxlength="10000"
                v-model="resumeText"
                placeholder="Paste your resume here..."
            />
            <img v-if="!!!resumeText" id="joebot" src="/img/joe_bot.png" alt="Jobscan Robot" />
        </div>
        <button @click="submitResume" :disabled="!!!resumeText" :class="{ error }">
            {{ error || loadingStatus || 'Scan' }}
        </button>
        <span class="formToggle" @click="$emit('toggleForm')">Upload Resume File Instead</span>
    </div>
</template>

<script>
import { getJDMatches } from '../../api/genericJobs';
export default {
    name: 'FilePaste',
    data() {
        return {
            resumeText: null,
            loadingStatus: null,
            error: null,
        };
    },
    watch: {
        error: function(error) {
            if (error) {
                setTimeout(() => (this.error = null), 3500);
            }
        },
    },
    methods: {
        submitResume: async function(e) {
            e.target.disabled = true;
            this.loadingStatus = '✅ Fetching recommendations...';
            const { error, data } = await getJDMatches(this.resumeText);
            if (error) {
                this.error = 'Unable to process resume. Please try again.';
                this.loadingStatus = null;
                this.resumeText = null;
                return;
            }
            const JDMatches = data.data;
            this.$router.push({
                name: 'CareerShiftResults',
                params: { recommendations: JDMatches.jds, skills: JDMatches.skills },
            });
            this.loadingStatus = null;
        },
    },
};
</script>

<style lang="less" scoped>
.formWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
#pasteZone {
    width: 100%;
    position: relative;
    border: solid 2px #7eccf2;
    background-color: white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    textarea {
        width: 100%;
        min-height: 315px;
        border: none;
        resize: none;
        background-color: transparent;
        box-sizing: border-box;
        padding: 2em;
    }
    img#joebot {
        position: absolute;
        bottom: 0;
        right: 1em;
        width: 150px;
        max-width: 25vw;
        transform-origin: center center;
        transition: 500ms ease-in-out;
    }
}
button {
    padding: 1em 2.5em;
    color: white;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.9em;
    background-color: #2aacea;
    border: none;
    margin-top: 1.5em;
    box-sizing: border-box;
    &:disabled {
        background-color: white;
        color: #777777;
    }
    &.error {
        border: solid 1px #ff6565;
        background-color: #fff5f5;
    }
}
.formToggle {
    display: block;
    font-size: 0.9em;
    text-transform: uppercase;
    color: #2aacea;
    cursor: pointer;
    width: 100%;
    text-align: center;
    margin-top: 0.5em;
}
</style>
